import { PRIMARY_THEME_COLOR } from "./theme.colors";

// eslint-disable-next-line
export default {
    color: {
        primary: "#0F9BB0",
        secondary: "#23AFC4",
        light: PRIMARY_THEME_COLOR,
        white: "#FFFFFF",
    },
    font: {
        fontFamilyPoppins: "Poppins",
    },
};
